<template>
  <base-dialog @handleConfirm="handleConfirm" @handleClose="handleClose" v-bind="$attrs">
    <template #title>退回重做</template>
    <div class="redo-body">
      是否将当前作业退回重做？
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/common/base-dialog';
import { updateFinish } from '@/services/editorApi';
export default {
  name: 'returnToRedoDialog',
  components: {
    BaseDialog
  },
  computed: {
    //获取任务信息
    getUrlInfo () {
      return this.$store.getters['editor/getUrlInfo'];
    },
  },
  methods: {
    handleClose () {
      this.$emit('handleClose');
    },
    async handleConfirm () {
      const { taskId } = this.getUrlInfo
      const { success } = await updateFinish({ taskId })
      if (success) {
        this.$emit('handleConfirm');
        location.reload();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.redo-body {
  width: 100%;
  text-align: center;
  font-size: 16px;
}
</style>